module.exports = __webpack_public_path__ + "static/media/add-user.e552d4e1.svg";